import logger from 'utils/logger.util';
import isDomElement from 'utils/predicates/dom/isDomElement.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('elementScrollTo');

// SEE: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView

const elementScrollTo = (options) => {
  const { quiet, element, ...extra } = options ?? {};

  if (!isDomElement(element)) {
    if (!quiet) L.warn('Invalid DOM element:', element);
    return void 1;
  }

  if (isNotFn(element.scrollIntoView)) {
    return void L.warn('Not a function element.scrollIntoView:', element.scrollIntoView);
  }

  try {
    const { behavior, block, inline, alignToTop } = extra;

    if (!Object.keys(extra).length) return element.scrollIntoView();
    if (alignToTop === true || alignToTop === false) return element.scrollIntoView(alignToTop);

    return element.scrollIntoView({ behavior, block, inline });
    //
  } catch (e) {
    return void L.warn('()', e);
  }
};

// noinspection JSUnusedGlobalSymbols
export default elementScrollTo;
